<template>
  <v-card class="mx-auto">
    <!-- src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg" -->
    <iframe
      height="200"
      :src="href"
      
      title="YouTube video player"
      frameborder="0"
      allow=""
      allowfullscreen
    ></iframe>
    <v-card-title>{{ title }}</v-card-title>
  </v-card>
</template>

<script>
export default {
  name: "YoutubeVideo",
  components: {},
  props: {
    title: { type: String, default: "" },
    href: { type: String, default: "" },
  },
  data: {},
  computed: {},
};
</script>

<style scoped lang="scss">
iframe{
  width: 100%;
}
</style>
